import { useCommonModals } from '../context/CommonModalsContext'
import { useCommonModalsLight } from '../context/CommonModalsLightContext'
import { useCurrentUser } from '../context/CurrentUserContext'
import { usePaddleBilling } from '../context/PaddleBillingContext'
import { trackSmartlookEventOnLimitedRequest } from '../utils/smartlookUtils'
import { TFrontendLimitType, TLimitType } from '../utils/types'

function useLimitedRequest(
  func: (...params: any[]) => Promise<any>,
  limitType?: TLimitType | TFrontendLimitType,
  errorAction: any = () => {},
) {
  const modalsConfigLight = useCommonModalsLight()
  const modalsConfig = useCommonModals()
  const { currentUser } = useCurrentUser()
  const { getLimitName, updateLimitData } = usePaddleBilling()

  return async (...params: any[]) => {
    try {
      const data = await func(...params)
      trackSmartlookEventOnLimitedRequest(limitType, getLimitName(limitType || ''), params)
      return data || true
    } catch (e: any) {
      errorAction()
      if (e.response?.status === 403 || e.response?.status === 401) {
        if (!currentUser) {
          modalsConfigLight.setLoginOpen(true)

          if (limitType !== 'projects') {
            modalsConfigLight.setLoginLimitType(limitType || null)
          }
        } else {
          modalsConfig.handleOpenPricing(true, limitType)
        }
        return false
      }
      console.error(e)
      throw new Error(e)
    } finally {
      await updateLimitData()
    }
  }
}

export default useLimitedRequest
